import { usePriceLive } from '@ui/hooks/price/usePriceLive';
import { isNil } from 'lodash-es';

import { useStableEntryPrice } from '../components/TradeModule/hooks/useStableEntryPrice';
import { useTradingPair } from '../store/useTradingPair';

export const useStableMarketPrice = () => {
  const tradingTokenBaseSymbol = useTradingPair(
    (s) => s.useTradingPair().baseSymbol,
  );
  const price = usePriceLive(tradingTokenBaseSymbol);
  
return useStableEntryPrice(isNil(price) ? undefined : price)?.toNumber();
};
